import AmioHttpService from './amio-http.service'

class IntegrationService extends AmioHttpService {
  listIntegrations() {
    return this.requestGet('/integrations')
      .then(response => response.data)
      .catch(err => {
        throw this.handleError(err)
      })
  }

  createIntegration(botId, data) {
    return this.requestPost(`/bots/${botId}/integrations`, data)
      .then(response => response.data)
      .catch(err => {
        throw this.handleError(err)
      })
  }

  updateIntegration(botId, integrationId, data) {
    return this.requestPatch(`/bots/${botId}/integrations/${integrationId}`, data)
      .then(response => response.data)
      .catch(err => {
        throw this.handleError(err)
      })
  }

  deleteIntegration(botId, integrationId) {
    return this.requestDelete(`/bots/${botId}/integrations/${integrationId}`)
      .then(response => response.data)
      .catch(err => {
        throw this.handleError(err)
      })
  }
}

export default new IntegrationService()
